import { axios } from '@Root/API'

export const getById = id => {
	return axios.get(`diocese/${id}`)
}
